/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { ResourceSavedNavigationDialogConfig } from "./model/resource-saved-navigation-dialog-config.model";
import {
  customerOfferRequestDetailUrl,
  customerOrderDetailUrl,
  relativeShipmentTimelineLatestSolutionUrl, sentRouteShareLocationUrl,
  shipmentTimelineOfferRequestUrl,
  shipmentTimelineOrderUrl,
  spOfferRequestDetailUrl
} from '@well/navigation';
import { translationSchema } from '@well/translation';

export namespace ResourceSavedNavigationState {

  export const customerOfferRequestSavedNavigationSuggestion = (uuid, backContext): ResourceSavedNavigationDialogConfig => ({
    backButtonLabel: 'delivery-app.navigation-suggestions.back.' + backContext,

    buttonsConfiguration: [{
      label: 'delivery-app.navigation-suggestions.offerRequestDetails',
      navigationUrl: customerOfferRequestDetailUrl(uuid)
    }]
  })

  export const subcontractingOfferRequestSavedNavigationSuggestion = (uuid, solutionUuid, backContext): ResourceSavedNavigationDialogConfig => ({
    backButtonLabel: 'delivery-app.navigation-suggestions.back.' + backContext,

    buttonsConfiguration: [{
      label: 'delivery-app.navigation-suggestions.shipmentGroupSolution',
      navigationUrl: relativeShipmentTimelineLatestSolutionUrl(uuid, solutionUuid)
    }]
  })

  export const spOfferRequestSavedNavigationSuggestion = (uuid, backContext): ResourceSavedNavigationDialogConfig => ({
    backButtonLabel: 'delivery-app.navigation-suggestions.back.' + backContext,

    buttonsConfiguration: [{
      label: 'delivery-app.navigation-suggestions.offerRequestDetails',
      navigationUrl: shipmentTimelineOfferRequestUrl(uuid, uuid)
    }]
  })

  export const offerBasedOnMasterRoutingSolSavedNavigationSuggestion = (uuid: any): ResourceSavedNavigationDialogConfig => ({
    buttonsConfiguration: [{
      label: 'delivery-app.navigation-suggestions.offerRequestDetails',
      navigationUrl: spOfferRequestDetailUrl(uuid)
    }]
  })

  export const orderOnCustomerBehalfSavedNavigationSuggestion = (orderUuid:string, spOrderUuid: string): ResourceSavedNavigationDialogConfig => ({
    backButtonLabel: 'delivery-app.navigation-suggestions.back.offer-request-details',
    buttonsConfiguration: [{
      label: 'delivery-app.navigation-suggestions.orderDetails',
      navigationUrl: shipmentTimelineOrderUrl(spOrderUuid, orderUuid)
    }]
  })

  export const orderOnVendorBehalfSavedNavigationSuggestion = (orderUuid: string): ResourceSavedNavigationDialogConfig => ({
    backButtonLabel: 'delivery-app.navigation-suggestions.back.offer-request-details',
    buttonsConfiguration: [{
      label: 'delivery-app.navigation-suggestions.orderDetails',
      navigationUrl: customerOrderDetailUrl(orderUuid)
    }]
  })

  export const contractOrderSavedNavigationSuggestion = (orderUuid: string): ResourceSavedNavigationDialogConfig => ({
    backButtonLabel: 'order.navigation-suggestions.back',
    buttonsConfiguration: [{
      label: 'order.details',
      navigationUrl: customerOrderDetailUrl(orderUuid)
    }]
  })

  export const routeShareLocationSavedNavigationSuggestion = (): ResourceSavedNavigationDialogConfig => ({
    backButtonLabel: translationSchema['route-share-location']['back'],
    buttonsConfiguration: [{
      label: translationSchema['route-share-location']['list'],
      navigationUrl: sentRouteShareLocationUrl
    }]
  })
}
